// Auto-generated cornerstone translation for ga.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:20:45.115572+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aip bhainistíochta capall: an rogha is fearr do 2026 | EquiSight",
      description: "Déan comparáid idir aipeanna bainistíochta capall d'úinéirí, stáblaí agus póraitheoirí. Faigh amach cén fáth gurb é EquiSight an aip iomlán do do chapall.",
      keywords: [
        "aip bhainistíochta capall",
        "aip bhainistíochta stábla",
        "aip dialainne capall",
        "aip chun roinnt capall a bhainistiú",
        "aip toirchis láraí",
        "aip phóraithe capall",
        "an aip bhainistíochta capall is fearr",
      ],
    },
    hero: {
      eyebrow: "Cabhair roghnóireachta · bogearraí bainistíochta capall",
      breadcrumbLabel: "Aip bhainistíochta capall",
      title: "Aip bhainistíochta capall: an treoir roghnóireachta iomlán d'úinéirí, stáblaí agus póraitheoirí.",
      intro: "Ní liosta gnéithe amháin é seo — comparáid chothrom, treoir roghnóireachta agus léargas ar a bhfuil aip bhainistíochta capall in ann a dhéanamh i ndáiríre in 2026. Do chapall amháin, do stábla iomlán, nó do do phóraíocht.",
      pills: [
        {
          icon: "Users",
          label: "D'úinéirí",
        },
        {
          icon: "Building2",
          label: "Do stáblaí",
        },
        {
          icon: "Baby",
          label: "Do phóraitheoirí",
        },
        {
          icon: "Share2",
          label: "Do fhoirne",
        },
      ],
      ctas: [
        {
          label: "Tosaigh saor in aisce le 1 capall",
          href: "#start",
          primary: true,
        },
        {
          label: "Go dtí an tábla comparáide",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Cén fáth a bhfuil aip bhainistíochta capall níos tábhachtaí ná riamh.",
      lead: "Sa chleachtas, tá bainistíocht capall scaipthe: WhatsApp, dialann, Excel, grianghraif ar do ghuthán, pas páipéir, sonraisc scaoilte agus socruithe béil. Míchaoithiúil fiú le capall amháin. Le roinnt capall, póraíocht nó cúram roinnte, tagann bearnaí, coinní caillte agus díospóidí chun cinn.",
      items: [
        "Cá raibh an dáta vacsaínithe sin arís?",
        "Cé a d'íoc an gabha?",
        "Cé acu láir a chaithfear a sheiceáil inniu?",
        "Ar léigh an traenálaí treoir na seachtaine seo caite?",
        "An ndearnas an cháipéis ghrianghraf sin a shábháil i ndáiríre?",
        "An bhfuil an sceideal beathaithe atá crochta sa stábla fós ceart?",
      ],
    },
    what: {
      title: "Cad is aip bhainistíochta capall ann?",
      lead: "Is comhad digiteach in aghaidh an chapaill é aip bhainistíochta capall ina bhunús. Gan nótaí scaipthe, ach áit amháin do shláinte, traenáil, cothú, cáipéisí, pleanáil, meabhrúcháin, costais, grianghraif, físeáin agus rochtain roinnte. Féachann gach duine timpeall an chapaill ar an bhfaisnéis chéanna, reatha.",
      targetGroupsTitle: "Cé dó a bhfuil aip bhainistíochta capall beartaithe?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Úinéir príobháideach",
          body: "Capall amháin, comhad amháin — sláinte, pleanáil agus stair i do phóca.",
        },
        {
          icon: "Users",
          title: "Úinéir le roinnt capall",
          body: "Próifílí ar leith, pleanáil ar leith, liosta tasc roinnte don fhoireann iomlán.",
        },
        {
          icon: "Building2",
          title: "Stábla lóistín & manach",
          body: "Rochtain úinéara, treoracha cúraim, clár ama roinnte agus tascanna.",
        },
        {
          icon: "Baby",
          title: "Póraíocht",
          body: "Timthriall láraí, toircheas, sonraí stalún, craobhghinealaigh agus forbairt searraigh.",
        },
        {
          icon: "Target",
          title: "Traenálaithe",
          body: "Léargas in aghaidh an chapaill, seisiúin a logáil, spriocanna a leagan síos, físeáin a anailísiú.",
        },
        {
          icon: "ClipboardList",
          title: "Gairmithe",
          body: "Gabha, fiaclóir, fisiteiripeoir nó tréidlia — ag obair ón gcomhad céanna.",
        },
      ],
    },
    criteria: {
      title: "Cad iad na critéir atá ag aip mhaith bhainistíochta capall?",
      lead: "Ní hé cuma na haipe amháin atá tábhachtach — caithfidh sí oibriú go praiticiúil gach lá. Cúig ghné nach féidir a bheith in easnamh sa rogha do 2026.",
      items: [
        {
          icon: "FileText",
          title: "Comhad capaill in aghaidh an chapaill",
          body: "Sonraí, aois, cine, faisnéis pasanna, úinéir, stábla, grianghraif agus cáipéisí — uile ceangailte le próifíl capaill amháin.",
        },
        {
          icon: "Heart",
          title: "Sláinte agus cúram",
          body: "Vacsaínithe, dífhaoithiú, gabha, fiaclóir, tréidlia, cóireálacha, cógas agus meabhrúcháin uathoibríocha roimh an dáta éaga.",
        },
        {
          icon: "Activity",
          title: "Traenáil agus dul chun cinn",
          body: "Traenálacha a logáil, nótaí, físeáin, torthaí comórtas, spriocanna agus dul chun cinn in aghaidh na disciplíne nó an chapaill.",
        },
        {
          icon: "Apple",
          title: "Cothú agus bainistíocht",
          body: "Sceidil beathaithe, forlíontáin, féar garbh, meáchan, riocht coirp agus an gnáthamh laethúil is gá don stábla a bheith ar an eolas faoi.",
        },
        {
          icon: "Share2",
          title: "Roinnt le daoine eile",
          body: "Rochtain d'úinéir, cúramóir, traenálaí, stáblaí nó gairmiúil — le bainistíocht ceadanna a fheileann do ról gach duine.",
        },
        {
          icon: "Calendar",
          title: "Pleanáil agus meabhrúcháin",
          body: "Clár ama roinnte le tascanna, meabhrúcháin uathoibríocha agus deimhniú ionas nach sleamhnaíonn aon rud tríd na bearnaí.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs aipeanna eile bainistíochta capall.",
      lead: "Faoi láthair, líonann Stalmanager, LogMyHorse, EquineM agus Happie Horse an SERP. Tá a láidreachtaí féin ag gach ceann acu. Cuirimid na gnéithe is mó a iarrtar taobh le taobh, go cothrom agus bunaithe ar fhaisnéis atá ar fáil go poiblí.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Tosaigh saor in aisce",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Roinnt capall",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Comhad sláinte",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Traenáil & dul chun cinn",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Cothú & forlíontáin",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pleanáil & meabhrúcháin",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Cáipéisí in aghaidh an chapaill",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Roinnt le foireann & ceadanna",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modúl póraíochta (iomlán)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Timthriall láraí",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pleanáil toirchis + éiceolaíochtaí",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Forbairt searraigh",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Gairmithe a chomhtháthú",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Léargais EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Oiriúnach d'úinéirí",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Oiriúnach do phóraíocht",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Oiriúnach do stábla/manach",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparáid bunaithe ar ghnéithe atá ar fáil go poiblí i mí Eanáir 2026. Is uirlisí maithe iad na hiomaitheoirí freisin; tógadh EquiSight chun na modúil go léir a chomhcheangal in aon aip amháin.",
    },
    why: {
      title: "Cén fáth go bhfuil EquiSight difriúil.",
      lead: "Cláraíonn dialann. Comhcheanglaíonn EquiSight bainistíocht capall, traenáil, cothú, sláinte, comórtais, gairmithe agus póraíocht in aon aip nua-aimseartha amháin — agus téann sé céim níos faide le léargais.",
      points: [
        {
          icon: "Heart",
          title: "Aip amháin do shaol iomlán an chapaill",
          body: "Ó searrach go capall spóirt, láir phóraithe nó capall ar scor. Fásann an comhad le do chapall — ní cailltear aon rud ar an mbealach.",
        },
        {
          icon: "Sparkles",
          title: "Ní hamháin sonraí, ach patrúin freisin",
          body: "Comhcheanglaíonn EquiCoach forbairt, gearáin athfhillteacha, traenáil agus cothú — ionas go bhfeiceann tú comharthaí in am, ní fógraí scaoilte.",
        },
        {
          icon: "Share2",
          title: "Tógtha le haghaidh comhoibrithe",
          body: "Oibríonn úinéir, stáblaí, traenálaí, gabha agus gairmithe eile ón gcomhad capaill céanna — leis na ceadanna a fheileann dá ról.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niche · póraíocht",
      title: "Bainistíocht capall do phóraitheoirí.",
      lead: "Luann go leor iomaitheoirí póraíocht in aon líne amháin. D'fhorbair EquiSight modúl póraíochta iomlán — toisc go mbíonn an phóraíocht ar an úsáideoir deireanach de ghnáth-aip annamh, ach go bhfuil an pleanáil ag teastáil níos mó uathu ná ó aon duine eile.",
      items: [
        "Timthriall láraí a thaifeadadh go laethúil",
        "Dáta insimnithe + sonraí stalún",
        "Seiceáil toirchis le héiceolaíochtaí",
        "Dáta ionchasach searraigh + rabhaidh",
        "Forbairt searraigh in aghaidh na míosa",
        "Craobhghinealaigh agus sinsearacht",
        "Nótaí in aghaidh na láraí",
        "Forbhreathnú ar gach láir thoirchí",
      ],
      ctaLabel: "Féach ar an modúl póraíochta",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niche · stábla & manach",
      title: "Bainistíocht capall do roinnt capall agus stáblaí lóistín.",
      lead: "Le roinnt capall, baineann sé níos lú le sonraí, agus níos mó le cumarsáid. Tá mianta, gnáthamha, socruithe beathaithe agus pointí leighis ar leith ag gach úinéir. Caithfidh gach fostaí a bheith in ann teacht orthu sin gan cuardach.",
      cards: [
        {
          t: "Capaill in aghaidh an úinéara",
          d: "Ní fheiceann gach úinéir ach a chapall/chapaill féin.",
        },
        {
          t: "Treoracha cúraim",
          d: "Le feiceáil in aghaidh an chapaill don stábla.",
        },
        {
          t: "Clár ama roinnte",
          d: "Gabha, tréidlia agus comórtais in aon amharc amháin.",
        },
        {
          t: "Liosta tasc",
          d: "Sannta d'fhostaithe, le deimhniú.",
        },
        {
          t: "Rochtain úinéara",
          d: "Feiceann custaiméirí a gcapall ina n-aip féin.",
        },
        {
          t: "Teagmhálaithe éigeandála",
          d: "Inaimsithe i gcónaí le linn strus sa stábla.",
        },
      ],
      ctaLabel: "Féach ar an modúl mainéise",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Ó WhatsApp, Excel agus clár bán go EquiSight.",
      lead: "Go nithiúil: mar seo a athraíonn do bhainistíocht capall laethúil.",
      rows: [
        {
          before: "Grúpaí WhatsApp",
          after: "Nótaí struchtúrtha in aghaidh an chapaill",
        },
        {
          before: "Scarbhileoga Excel",
          after: "Comhad capaill beo le stair",
        },
        {
          before: "Clár bán sa stábla",
          after: "Pleanáil roinnte ar do ghuthán",
        },
        {
          before: "Grianghraif scaoilte ar cheamara",
          after: "Meáin ceangailte le do chapall",
        },
        {
          before: "Socruithe béil",
          after: "Tascanna agus meabhrúcháin le deimhniú",
        },
        {
          before: "Pas páipéir caillte",
          after: "Cáipéisí ar fáil i gcónaí",
        },
      ],
    },
    helper: {
      title: "Cé acu aip bhainistíochta capall a oireann duitse?",
      lead: "Freagair na 5 cheist seo agus gheobhaidh tú moladh cothrom — fiú mura EquiSight an freagra i gcónaí.",
      questions: [
        {
          id: "horses",
          q: "An bhfuil capall amháin agat nó roinnt capall?",
          options: [
            {
              label: "Capall amháin",
              score: 1,
            },
            {
              label: "2–5 capall",
              score: 2,
            },
            {
              label: "Níos mó ná 5 capall",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "An mbainistíonn tú capaill custaiméirí nó tríú páirtithe?",
          options: [
            {
              label: "Ní dhéanaim, mo chapaill féin amháin",
              score: 0,
            },
            {
              label: "Uaireanta — do theaghlach nó cairde",
              score: 1,
            },
            {
              label: "Déanaim, go gairmiúil (stábla / manach)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Ar mhaith leat póraíocht agus toircheas a thaifeadadh?",
          options: [
            {
              label: "Níl sé ábhartha",
              score: 0,
            },
            {
              label: "Uaireanta — póraíocht ócáideach",
              score: 1,
            },
            {
              label: "Sea, táim (nó beidh mé) i mo phóraítheoir",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "An oibríonn tú le traenálaí, cúramóir nó gairmiúil?",
          options: [
            {
              label: "Ní oibrím, déanaim gach rud mé féin",
              score: 0,
            },
            {
              label: "Sea, le 1 duine",
              score: 1,
            },
            {
              label: "Sea, le roinnt daoine",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Ar mhaith leat ach taifeadadh, nó léargais a fháil freisin?",
          options: [
            {
              label: "Taifeadadh amháin",
              score: 1,
            },
            {
              label: "Taifeadadh + pleanáil",
              score: 2,
            },
            {
              label: "Taifeadadh + pleanáil + léargais",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Tá dialann shimplí go leor — agus fásann sí leat.",
          body: "Do chapall amháin gan cúram roinnte, oireann aon aip bhainistíochta capall. Tosaíonn EquiSight saor in aisce le 1 capall, mar sin níl aon riosca ann. Ba mhaith leat níos mó capall, traenálaí nó póraíocht a chur leis níos déanaí, tá gach rud ann cheana féin.",
          cta: "Tosaigh saor in aisce le 1 capall",
        },
        mid: {
          title: "Oireann EquiSight go maith do do chás.",
          body: "Tá riachtanais iolracha agat (roinnt capall, comhoibriú nó léargais). Clúdaíonn an chuid is mó d'iomaitheoirí 1-2 mhodúl; comhcheanglaíonn EquiSight iad in aon aip amháin, gan uirlisí ar leith a nascadh.",
          cta: "Féach ar a bhfuil EquiSight in ann a dhéanamh",
        },
        high: {
          title: "Is é EquiSight an rogha is loighciúla.",
          body: "Comhcheanglaíonn do chás roinnt capall, comhoibriú, póraíocht agus/nó léargais. Is díreach anseo a dhéanann EquiSight an difríocht — gan uirlisí scaipthe, ach comhad capaill amháin do gach rud agus do gach duine timpeall an chapaill.",
          cta: "Tosaigh saor in aisce le EquiSight",
        },
      },
    },
    faqTitle: "Ceisteanna coitianta faoi aipeanna bainistíochta capall",
    faq: [
      {
        q: "Cad í an aip bhainistíochta capall is fearr?",
        a: "Braitheann an aip bhainistíochta capall is fearr ar do chás féin. Do dhialann shimplí amháin, oireann roinnt aipeanna. Más mian leat sláinte, traenáil, cothú, cáipéisí, póraíocht, pleanáil agus comhoibriú a chomhcheangal, tógadh EquiSight mar réiteach iomlán ina dtagann gach rud le chéile in aon chomhad amháin.",
      },
      {
        q: "An féidir liom roinnt capall a bhainistiú in aon aip amháin?",
        a: "Is féidir. Caithfidh aip mhaith bhainistíochta capall tacú le roinnt capall, lena n-áirítear úinéirí, cúramóirí, gnáthamha, cáipéisí, coinní agus meabhrúcháin in aghaidh an chapaill. Dearadh EquiSight ón gcéad líne cód ar aghaidh — is comhaid aonair iad capaill, ní sraitheanna i liosta.",
      },
      {
        q: "An oireann EquiSight do phóraitheoirí freisin?",
        a: "Oireann. Is féidir EquiSight a chumrú le gnéithe póraíochta mar thimthriall láraí, dáta insimnithe, seiceáil toirchis, sonraí stalún, craobhghinealaigh, dáta ionchasach searraigh agus forbairt searraigh. Is é seo go díreach an réimse nach dtugann an chuid is mó d'aipeanna iomaíocha aon aird air nó aird bheag air.",
      },
      {
        q: "An féidir liom sonraí a roinnt le mo thraenálaí nó mo ghabha?",
        a: "Is féidir. Is é cuspóir EquiSight go gcomhroinntear faisnéis ábhartha go sábháilte le daoine timpeall an chapaill — traenálaí, gabha, fiaclóir, tréidlia, fisiteiripeoir, cúramóir nó úinéir. Ní fhaigheann gach duine ach na ceadanna atá riachtanach dá ról.",
      },
      {
        q: "Cén fáth gan WhatsApp nó Excel a úsáid?",
        a: "Oibríonn WhatsApp agus Excel chomh fada agus a fhanann rudaí simplí. A luaithe a bhíonn roinnt capall, coinní, cáipéisí, cóireálacha, úinéirí nó sonraí póraíochta agat, éiríonn sé so-earráide: scaipeann faisnéis, caitear am ag cuardach agus imíonn socruithe béil i ndearmad. Tugann aip bhainistíochta capall gach rud le chéile in aghaidh an chapaill, le meabhrúcháin uathoibríocha.",
      },
      {
        q: "Cad a chosnaíonn EquiSight?",
        a: "Is féidir leat tosaigh saor in aisce le 1 capall. Más mian leat roinnt capall a bhainistiú, póraíocht a ghníomhachtú nó rochtain a thabhairt do ghairmithe, tá pleananna Premium inacmhainne ar fáil. Féach na roghanna reatha ar leathanach na bpraghsanna.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Bogadóireacht bogearraí capall: comparáid iomlán 2026",
      description: "Déan comparáid idir bogearraí bogadóireachta do chapaill: timthriall láir, toircheas, roghnú stail agus searraigh. Faigh amach cén fáth gur í EquiSight an aip bogadóireachta is iomláine.",
      keywords: [
        "bogadóireacht bogearraí capall",
        "aip timthriall láir",
        "aip toircheas láir",
        "aip clárú searraigh",
        "aip stud-leabhar capall",
        "pleanáil clúdaigh capall",
        "aip roghnú stail",
      ],
    },
    hero: {
      eyebrow: "Treoir roghnaithe · bogearraí bogadóireachta",
      breadcrumbLabel: "Bogearraí bogadóireachta",
      title: "Bogearraí bogadóireachta do chapaill: an comparáid iomlán do 2026.",
      intro: "Is fiú níos mó ná aip ghinearálta bainistíochta capall a bheith ag láir bhogadóireachta. Déan comparáid idir gnéithe bogadóireachta na n-uirlisí is cáiliúla, faigh amach cad air a bhfuil tú ag brath go fírinneach, agus roghnaigh go feasach an bogearraí a oireann do do stud — mór nó beag.",
      pills: [
        {
          icon: "Baby",
          label: "Timthriall láir",
        },
        {
          icon: "Heart",
          label: "Seiceáil toirchis",
        },
        {
          icon: "Sparkles",
          label: "Forbairt searraigh",
        },
        {
          icon: "FileText",
          label: "Stud-leabhar",
        },
      ],
      ctas: [
        {
          label: "Tosaigh saor in aisce leis an modúl bogadóireachta",
          href: "#start",
          primary: true,
        },
        {
          label: "Chuig an tábla comparáide",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Cén fáth nach leor aip ghnáth bainistíochta capall do bhogadóireacht.",
      lead: "Tá an chuid is mó d'aipeanna spóirt chapall deartha do chapall spóirt nó fóillíochta amháin. Tá rithim an-difriúil ag bogadóireacht: teas, insiniú, seiceáil toirchis, echograph, féilire searraigh, crann ginealaigh agus díol. Cailleann Excel a threoir tar éis 2 shéasúr — agus le roinnt láracha, cailleann tú greim.",
      items: [
        "Cathain a bhí an timthriall deireanach ag Bonita arís?",
        "Cén stail atá beartaithe don chlúdach an séasúr seo chugainn?",
        "An bhfuil an echograph 21-lá curtha ar an gclár cheana?",
        "Cé na searraigh ó 2024 atá díolta cheana?",
        "Cá bhfuil léaráid an chrainn ginealaigh go dtí seanathair ón taobh máthartha?",
        "Cá bhfuil na samplaí DNA agus sonraí pas?",
      ],
    },
    what: {
      title: "Cad iad bogearraí bogadóireachta do chapaill?",
      lead: "Is comhad speisialaithe é bogearraí bogadóireachta do gach láir agus stail, in éineacht le féilire bliana bogadóireachta, pleanáil toirchis, clárú searraigh agus taispeáint crann ginealaigh. Ní dialann ghinearálta capaill é, ach uirlis a thuigeann an timthriall bogadóireachta: ón chéad teas go dtí an scaradh ón láir.",
      targetGroupsTitle: "Cén cineál bogadóra atá bogearraí bogadóireachta dírithe air?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Bogadóir caitheamh aimsire (1-3 láracha)",
          body: "Clúdach nó dhó in aghaidh na bliana — forbhreathnú gan aclaíocht Excel.",
        },
        {
          icon: "Building2",
          title: "Stud beag (4-10 láracha)",
          body: "Plean bliana bogadóireachta le timthriall, insiniú, seiceálacha toirchis agus comhad searraigh.",
        },
        {
          icon: "Users",
          title: "Stud gairmiúil (10+)",
          body: "Foireann iolrach, roghnú stail in aghaidh gach láir, díol agus margaíocht.",
        },
        {
          icon: "Target",
          title: "Sealbhóir stail",
          body: "Stair orduithe, staitisticí speirme agus clár in aghaidh gach stail.",
        },
        {
          icon: "Heart",
          title: "Trasphlandú suthanna",
          body: "Láir dheonaí + láir fhaighteora mar chomhad nasctha, féilire ET.",
        },
        {
          icon: "ClipboardList",
          title: "Clárú stud-leabhair",
          body: "Samplaí DNA, doiciméid pas agus sonraí crann ginealaigh.",
        },
      ],
    },
    criteria: {
      title: "Cad is gá do bhogearraí bogadóireachta maithe a chomhlíonadh?",
      lead: "Ní ionann gach 'gné bogadóireachta' in aip capaill. Cúig phríomhréimse ina gcailleann bogadóirí go leor ama — agus inar féidir le bogearraí difear fíor a dhéanamh.",
      items: [
        {
          icon: "Calendar",
          title: "Timthriall láir & teas",
          body: "Loga laethúil, uibhlú tuartha, leanúint in aghaidh gach timthrialla agus meabhrúcháin uathoibríocha.",
        },
        {
          icon: "Heart",
          title: "Insiniú & seiceáil toirchis",
          body: "Dátaí clúdaigh agus insinithe, sonraí stail, echograph 14 lá, 21 lá, 60 lá agus cinneadh gnéis.",
        },
        {
          icon: "Baby",
          title: "Forbairt searraigh",
          body: "Sonraí breithe, graf meáchain, sceideal díríothlaithe, am scartha, clárú pais.",
        },
        {
          icon: "FileText",
          title: "Crann ginealaigh & páipéir",
          body: "Taispeáint crann ginealaigh go 4-5 glúin, DNA, uimhreacha pas agus stádas stud-leabhair.",
        },
        {
          icon: "Target",
          title: "Roghnú stail & meaitseáil",
          body: "Scagadh de réir disciplín, línte, sonraí stail agus rath stairiúil — ní amháin cad a chuireann sealbhóir stail chun cinn.",
        },
        {
          icon: "Share2",
          title: "Comhoibriú le tréidlia/insinitheoir",
          body: "Echographanna, samplaí agus stádais roinnte go díreach leis an gcleachtas a oibríonn le do láracha.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs bogearraí bogadóireachta eile.",
      lead: "Léiríonn SERP na hÍsiltíre do bhogearraí bogadóireachta aipeanna capaill ginearálta go minic a luann bogadóireacht in aon líne amháin. Déanaimid comparáid chóir idir na huirlisí a bhfuil sreabhadh bogadóireachta iomlán acu go fírinneach.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Tosaigh saor in aisce",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Loga timthriall láir",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dáta insinithe + stail",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Echographanna & seiceáil toirchis",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Dáta breithe searraigh ionchais",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Comhad searraigh (meáchan/fás)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Crann ginealaigh go 4-5 glúin",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Clárú DNA & pais",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Roghnú stail / meaitseáil",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / trasphlandú suthanna",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Forbhreathnú il-láracha",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Móibíleach (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Roinnt le tréidlia",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Comhtháite le comhad ginearálta",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Díol & margaíocht searraigh",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparáid bunaithe ar ghnéithe atá ar fáil go poiblí i mí Eanáir 2026. Tá EquineGenie láidir i mbogadóireacht, ach níos laige i mbainistíocht mhóibíleach + ghinearálta capall. Comhcheanglaíonn EquiSight an dá rud.",
    },
    why: {
      title: "Cén fáth a bhfreastalaíonn EquiSight ar bhogadóirí ar bhealach difriúil.",
      lead: "Oibríonn go leor bogadóirí le bogearraí bogadóireachta ar leith agus le haip bainistíochta capall ar leith. Comhcheanglaíonn EquiSight an dá rud — gan athrú idir aipeanna nó sonraí a iontráil faoi dhó.",
      points: [
        {
          icon: "Heart",
          title: "Fanann láir bhogadóireachta ina gnáthcapall freisin",
          body: "Tá blian bogadóireachta agus comhad gnáth-chapall ag an láir bhogadóireachta — sláinte, vacsaínithe, gabha. Aon aip amháin, gach modúl.",
        },
        {
          icon: "Sparkles",
          title: "Tuartha seachas imoibríoch",
          body: "Tuar timthrialla, meabhrúcháin chloch mhíle toirchis agus féilire searraigh — go huathoibríoch bunaithe ar do shonraí.",
        },
        {
          icon: "Share2",
          title: "Gach duine timpeall ar an mbogadóireacht",
          body: "Insinitheoir, sealbhóir stail, tréidlia, ceannaitheoir, stud-leabhar — rochtain ag gach duine leis na cearta cuí.",
        },
      ],
    },
    nicheA: {
      eyebrow: "In aghaidh gach disciplín · ón timthriall go dtí an scaradh",
      title: "Cad atá i gcomhad bogadóireachta in EquiSight.",
      lead: "Faigheann tú comhad bogadóireachta iomlán in aghaidh gach láir, nasctha lena comhad gnáth-chapall.",
      items: [
        "Loga timthrialla laethúil le tuar",
        "Insiniú/clúdach + sonraí stail",
        "Líne ama echograph (14/21/60 lá + gnéas)",
        "Clocha míle toirchis le meabhrúcháin uathoibríocha",
        "Dáta breithe searraigh ionchais agus ullmhúchán",
        "Comhad searraigh ón mbreith ar aghaidh",
        "Crann ginealaigh go seanmháthair/seanathair le nascleanúint chliceála",
        "Sampla DNA, pas, stádas stud-leabhair",
        "Píblíne díola le daoine ar spéis leo",
        "Stair roghnaithe stail in aghaidh gach láir",
      ],
      ctaLabel: "Féach ar an modúl bogadóireachta",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Don stud iomlán",
      title: "Forbhreathnú ar roinnt láracha agus stail.",
      lead: "Nuair a bhíonn níos mó ná 2-3 láracha á dtógáil agat, éiríonn forbhreathnú ar gach timthriall agus toircheas ríthábhachtach.",
      cards: [
        {
          t: "Deais timthrialla",
          d: "Gach láir taobh le taobh, le céim timthrialla agus an chéad ghníomh eile.",
        },
        {
          t: "Píblíne toirchis",
          d: "Cé na láracha atá cá háit sna clocha míle toirchis?",
        },
        {
          t: "Féilire searraigh",
          d: "Breitheanna ionchais in aghaidh gach míosa, le lóistíocht ailínithe leis.",
        },
        {
          t: "Punann stail",
          d: "Stail féin nó insinítheoirí seasta le stair orduithe.",
        },
        {
          t: "Graf crann ginealaigh",
          d: "Anailís sinsear thar roinnt glúnta agus línte.",
        },
        {
          t: "Deais díola",
          d: "Cé na searraigh atá díolta, curtha i leataobh nó fós ar fáil.",
        },
      ],
    },
    beforeAfter: {
      title: "Ó Excel + clár go EquiSight bogadóireacht.",
      lead: "Go sonrach: mar seo a athraíonn do shéasúr bogadóireachta.",
      rows: [
        {
          before: "Timthriall i nóta scaoilte",
          after: "Loga laethúil le tuar",
        },
        {
          before: "Echographanna trí WhatsApp chuig insinitheoir",
          after: "Comhad roinnte le grianghraif",
        },
        {
          before: "Dáta toirchis i gclár",
          after: "Meabhrúcháin chloch mhíle uathoibríocha",
        },
        {
          before: "Pas searraigh i dtarrainteán",
          after: "Doiciméad nasctha le próifíl searraigh",
        },
        {
          before: "Crann ginealaigh ar pháipéar",
          after: "Crann ginealaigh inchliccáilte go 4-5 glúin",
        },
        {
          before: "Fógra díola ar Marktplaats",
          after: "Píblíne díola le liosta spéise",
        },
      ],
    },
    helper: {
      title: "Cé acu bogearraí bogadóireachta a oireann duit?",
      lead: "5 cheist le féachaint an bhfuil gá agat le haip bhogadóireachta iomlán nó an leor uirlis chaitheamh aimsire.",
      questions: [
        {
          id: "mares",
          q: "Cé mhéad láir bhogadóireachta a bhainistíonn tú?",
          options: [
            {
              label: "1 láir",
              score: 1,
            },
            {
              label: "2-5 láracha",
              score: 2,
            },
            {
              label: "Níos mó ná 5 láracha",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Cé chomh minic a tógann tú in aghaidh na bliana?",
          options: [
            {
              label: "Ó am go chéile (gach cúpla bliain)",
              score: 0,
            },
            {
              label: "1-2 chlúdach gach bliain",
              score: 2,
            },
            {
              label: "3+ clúdach gach bliain",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Conas a dheineann tú insiniú/clúdach?",
          options: [
            {
              label: "Clúdach nádúrtha",
              score: 1,
            },
            {
              label: "Insiniú saorga, speirm úr/fuaraithe",
              score: 2,
            },
            {
              label: "ET nó reoite domhain",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "An oibríonn tú i gcomhar le tréidlia/insinitheoir?",
          options: [
            {
              label: "Duine amháin seasta",
              score: 1,
            },
            {
              label: "Cleachtais iolracha",
              score: 2,
            },
            {
              label: "Líonra idirnáisiúnta",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Cad a choimeádann tú súil air faoi láthair?",
          options: [
            {
              label: "Excel nó páipéar",
              score: 1,
            },
            {
              label: "Aip ghinearálta bainistíochta capall",
              score: 2,
            },
            {
              label: "Ní choimeádaim aon rud struchtúrtha",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Leor uirlis chaitheamh aimsire nó Excel — ach tá EquiSight fónta fós.",
          body: "Do 1 láir le clúdach nádúrtha gach cúpla bliain, is ró-mhór modúl bogadóireachta cuimsitheach. Tosaíonn EquiSight saor in aisce agus ní ghníomhachtaíonn tú an modúl bogadóireachta ach don bhliain ina gcludaíonn tú — gan oibleagáid uasghrádaithe.",
          cta: "Tosaigh saor in aisce",
        },
        mid: {
          title: "Is í EquiSight bogadóireacht an uirlis cheart.",
          body: "Tá roinnt láracha nó roinnt modhanna bogadóireachta agat — níl aipeanna ginearálta capaill tógtha chuige sin. Comhcheanglaíonn EquiSight bogadóireacht + cúram ginearálta, ionas nach n-athraíonn tú idir dhá uirlis.",
          cta: "Féach ar an modúl bogadóireachta",
        },
        high: {
          title: "Tá EquiSight tógtha do do stud.",
          body: "Roinnt láracha, ET nó reoite domhain, foireann idirnáisiúnta — tagann an chuid is mó d'uirlisí gearr anseo. Scálaíonn EquiSight go leibhéal stud gan ceadúnais bhreise a charnú.",
          cta: "Labhair linn faoi phlean Stud",
        },
      },
    },
    faqTitle: "Ceisteanna coitianta faoi bhogearraí bogadóireachta",
    faq: [
      {
        q: "Cad iad na bogearraí bogadóireachta is fearr do chapaill?",
        a: "Do 1 láir gan modh bogadóireachta casta, leor go leor uirlisí. Ó 2-3 láracha ar aghaidh, le húsáid insinithe shaorga nó ET, nó comhoibriú le tréidlia agus stud-leabhar, éiríonn modúl bogadóireachta iomlán ríthábhachtach. Comhcheanglaíonn EquiSight bogadóireacht le bainistíocht ghinearálta capall in aon aip amháin, ionas nach gá duit athrú.",
      },
      {
        q: "Cé na gnéithe bogadóireachta atá de dhíth orm go fírinneach?",
        a: "Ar a laghad: loga timthrialla, sonraí insinithe/clúdaigh, clocha míle seiceála toirchis, agus comhad searraigh. Roghnach ach cumhachtach: taispeáint crann ginealaigh, cartlann roghnaithe stail, DNA/pas agus píblíne díola.",
      },
      {
        q: "An féidir le EquiSight timthriall láir a thuar?",
        a: "Is féidir. Úsáideann EquiSight sonraí timthrialla roimhe seo chun an t-uibhlú tuartha a thaispeáint, ionas go bpleanálann tú insiniú nó clúdach ag an am ceart — gan míniú laethúil.",
      },
      {
        q: "An n-oibríonn EquiSight le trasphlandú suthanna freisin?",
        a: "Is ea. Faigheann láir dheonaí agus láir fhaighteora comhaid nasctha, féilire ET agus clocha míle roinnte leis an gcleachtas. Mar sin ní chailleann tú aon líne ama sa sreabhadh ET casta.",
      },
      {
        q: "An féidir liom mo shonraí bogadóireachta reatha a iompórtáil?",
        a: "Is féidir leat sonraí timthrialla, clúdaigh agus searraigh a iontráil de láimh nó ina mbaisceanna trí CSV. I gcás bogadóireachtaí gníomhacha, cuidímid le himirce aonuaire má tá sonraí ó roinnt séasúr agat.",
      },
      {
        q: "Conas a roinnim comhad le mo thréidlia nó insinitheoir?",
        a: "Faigheann gach duine rochtain le ról: tréidlia, insinitheoir, sealbhóir stail nó oifigeach stud-leabhair. Ní fheiceann gach duine ach an fhaisnéis atá ag teastáil dá ról — níl gá le rochtain iomlán.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Boghdán bogearraí: comparáid iomlán & treoir roghnaithe 2026",
      description: "Déan comparáid idir bogearraí boghdáin do cheachtanna, marcaigh, capaill agus riarachán. Faigh amach cén aip a oireann do do bhoghdán nó do do stábla pinsean.",
      keywords: [
        "bogearraí boghdáin",
        "aip bhainistíochta stábla",
        "bogearraí riaracháin boghdáin",
        "pleanáil ceachtanna boghdáin",
        "bogearraí stábla pinsean",
        "riarachán marcach",
        "riarachán capall boghdáin",
      ],
    },
    hero: {
      eyebrow: "Treoir roghnaithe · bogearraí boghdáin",
      breadcrumbLabel: "Bogearraí boghdáin",
      title: "Bogearraí boghdáin: an treoir roghnaithe iomlán do bhoghdáin agus stáblaí pinsean.",
      intro: "Pleanáil ceachtanna, riarachán marcach, bainistíocht capall, fáltanas agus cumarsáid — cuireann bogearraí boghdáin maithe an méid sin ar fad le chéile. Déan comparáid idir na roghanna is cáiliúla agus faigh amach cé acu a oireann do do stábla nó do bhoghdán.",
      pills: [
        {
          icon: "Calendar",
          label: "Pleanáil ceachtanna",
        },
        {
          icon: "Users",
          label: "Marcaigh & cliaint",
        },
        {
          icon: "Heart",
          label: "Cúram capall",
        },
        {
          icon: "CreditCard",
          label: "Fáltanas",
        },
      ],
      ctas: [
        {
          label: "Iarr léiriú",
          href: "#start",
          primary: true,
        },
        {
          label: "Go dtí an tábla comparáide",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Cén fáth a ndéanann uirlisí scaipthe boghdán a mhoilliú.",
      lead: "Oibríonn an chuid is mó de bhoghdáin ar fheiste ilphíosaí: pleanáil ceachtanna ar chlár bán, clárú marcach in Excel, fáltanas in uirlis eile, cúram capall ar WhatsApp agus teagmháil le húinéirí trí theachtaireachtaí pearsanta. I seachtain rógnóthach tagann áirithintí dúbailte, sonraisc dearmadta nó capaill nach bhfuil a fhios acu cé an marcach a fháil.",
      items: [
        "Cé atá ag ceacht anois le Jasmijn?",
        "Cé an marcach nár íoc as Márta fós?",
        "Cé an capall nach féidir a úsáid an tseachtain seo?",
        "Cé hiad teagmhálaithe éigeandála na ndaltaí?",
        "Ar fuair úinéir Stardust sonrasc an ghabhann crú fós?",
        "Cé an capall atá i gcé an bosca?",
      ],
    },
    what: {
      title: "Cad iad bogearraí boghdáin?",
      lead: "Comhcheanglaíonn bogearraí boghdáin pleanáil ceachtanna, riarachán marcach, bainistíocht capall, fáltanas agus cumarsáid in aon uirlis amháin. Gan acrobataic Excel ná spaigeití WhatsApp, ach aon áit amháin ina n-oibríonn an boghdán agus ina bhfeiceann úinéirí/marcaigh a raon féin.",
      targetGroupsTitle: "Cén cineál gnó ar a bhfuil bogearraí boghdáin dírithe?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Boghdán beag (1-15 capall)",
          body: "Pleanáil ceachtanna agus íocaíochtaí den chuid is mó — riarachán gan tinneas cinn.",
        },
        {
          icon: "Users",
          title: "Boghdán meánmhéide (15-40 capall)",
          body: "Múinteoirí iolracha, pleanáil ceachtanna + sceideal capall + riarachán marcach.",
        },
        {
          icon: "ClipboardList",
          title: "Stábla mór marcaíochta agus pinsean (40+)",
          body: "Oibríocht iomlán lena n-áirítear fáltanas, pleanáil beatha agus gabha crú.",
        },
        {
          icon: "Heart",
          title: "Stábla pinsean",
          body: "Tairseach úinéara, treoracha cúraim aonair, clár comhroinnte.",
        },
        {
          icon: "Target",
          title: "Stábla traenála léimneachán",
          body: "Pleanáil comórtais, traenáil per capall, teagmháil le cliaint.",
        },
        {
          icon: "FileText",
          title: "Fiontraithe eachtraíochta",
          body: "Meascán de cheachtanna + pinsean + clinic + trádáil — ar fad ó aon chóras amháin.",
        },
      ],
    },
    criteria: {
      title: "Cad ar cheart do bhogearraí boghdáin maithe cloí leis?",
      lead: "Ní chiallaíonn aip álainn faic mura n-oibreoidh do chuid fostaithe léi. Cúig chritéar praiticiúil a dhéanann an difríocht idir rath agus éadóchas.",
      items: [
        {
          icon: "Calendar",
          title: "Pleanáil ceachtanna ar leibhéil iolracha",
          body: "Tosaitheoir/ardleibhéal, dreamasúir/léimneachán, naisc capall agus cláranna múinteora — ar fad le feiceáil taobh le taobh.",
        },
        {
          icon: "Users",
          title: "Riarachán marcach",
          body: "Próifílí, leibhéal, síntiús, cárta ceachta agus naisc baill teaghlaigh do mharcaigh óga.",
        },
        {
          icon: "Heart",
          title: "Sceideal capall",
          body: "Cé chomh minic is a úsáidtear capall, le tréimhsí scíthe, gortaithe agus téarnaimh.",
        },
        {
          icon: "CreditCard",
          title: "Fáltanas & síntiúis",
          body: "Síntiúis mhíosúla, cártaí ceachta, ceachtanna aonair agus bailiúchán uathoibríoch.",
        },
        {
          icon: "Share2",
          title: "Tairseach úinéara (stábla pinsean)",
          body: "Feiceann úinéirí a gcapall ina n-aip féin — clár, costais, gabha crú agus nótaí gan glaoch gutháin.",
        },
        {
          icon: "Bell",
          title: "Cumarsáid & meabhrúcháin",
          body: "Meabhrúcháin cheachta uathoibríocha, fógraí íocaíochta, fógraí gabha crú — gan WhatsApp.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs bogearraí boghdáin eile.",
      lead: "Tá go leor uirlisí boghdáin láidir i gpleanáil ceachtanna nó i bhfáltanas, ach is annamh i gcúram capall agus cumarsáid úinéara le chéile. Cuirimid na roghanna ar fad i gcomparáid go cothrom.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Tús saor / tréimhse triail",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Pleanáil ceachtanna",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Múinteoirí iolracha",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Riarachán marcach",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sceideal capall",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cúram capall (vacsaíniú/gabha crú)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cárta ceachta / síntiús",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Íocaíochtaí ar líne",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Fáltanas uathoibríoch",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Tairseach úinéara (pinsean)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Comhtháthú gabha crú/tréidlia",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Meabhrúcháin WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Soghluaiste (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pleanáil comórtais",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Oiriúnach do stábla pinsean",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparáid bunaithe ar ghnéithe atá ar fáil go poiblí i Eanáir 2026. Tá Stalmanager láidir i riarachán, scarann EquiSight é féin in sreabhadh stábla pinsean + cúram capall + tairseach úinéara.",
    },
    why: {
      title: "Cén fáth go bhfuil EquiSight difriúil do bhoghdáin agus stáblaí pinsean.",
      lead: "Téann EquiSight níos faide ná pleanálaí ceachtanna. Feicimid boghdán mar oibríocht iomlán: capaill, daoine, cumarsáid agus airgead — ag brath ar a chéile ar fad.",
      points: [
        {
          icon: "Heart",
          title: "An capall i lár an aonaigh, ní an clár",
          body: "Tá a chlárthaifeadta féin ag gach capall. Úsáid ceachtanna, sláinte, gabha crú agus comórtais in aon amlíne amháin — ní 3 uirlis ar leith.",
        },
        {
          icon: "Share2",
          title: "Úinéirí ag féachaint gan glaoch",
          body: "Tá a radharc féin ag úinéirí stábla pinsean: costais, pleanáil, grianghraif agus nótaí — sábhálann sé 5-10 glaoch gutháin in aghaidh na seachtaine.",
        },
        {
          icon: "Bell",
          title: "Cumarsáid uathoibríoch",
          body: "Meabhrúchán ceachta, meabhrúchán vacsaíniú, sonrasc — uathoibríoch, trí aip/ríomhphost/SMS. Gan WhatsApp craolacháin a thuilleadh.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Don stábla pinsean",
      title: "Cad a fhaigheann stábla pinsean ó EquiSight.",
      lead: "Tá dúshláin uathúla ag stáblaí pinsean nach réitíonn bogearraí boghdáin gnátha.",
      cards: [
        {
          t: "Tairseach úinéara",
          d: "Feiceann gach úinéir a c(h)apall féin, a c(h)lár agus a c(h)ostais amháin.",
        },
        {
          t: "Treoracha cúraim per capall",
          d: "Bia, féar garbh, forlíontáin, sceideal blaincéid — le feiceáil ag an stábla.",
        },
        {
          t: "Clár comhroinnte",
          d: "Gabha crú, tréidlia agus cuairt úinéara in aon radharc amháin.",
        },
        {
          t: "Costais tomhaltais per capall",
          d: "Luíochán, bia, beathú cothú curtha ar aghaidh per úinéir.",
        },
        {
          t: "Teagmhálaithe éigeandála capall",
          d: "Úinéir + tréidlia + gabha crú inaimsithe ag an stábla i gcónaí.",
        },
        {
          t: "Bainistíocht saoire",
          d: "Cé na capaill a théann go féarach, ar scíth nó i dtéarnamh?",
        },
      ],
    },
    beforeAfter: {
      title: "Ó chlár bán + Excel go EquiSight.",
      lead: "Go sonrach: seo mar a athraíonn seachtain oibre sa bhoghdán.",
      rows: [
        {
          before: "Clár bán le pleanáil ceachtanna",
          after: "Pleanáil beo per múinteoir",
        },
        {
          before: "Excel le marcaigh + nótaí ceachta",
          after: "CRM cliaint le stair ceachtanna",
        },
        {
          before: "WhatsApp chuig úinéirí",
          after: "Tairseach úinéirí dá gcapall",
        },
        {
          before: "Bailiúchán míosúil de láimh",
          after: "Fáltanas uathoibríoch + iDEAL",
        },
        {
          before: "Cúram capall ar chlár beartáin páipéir",
          after: "Treoracha cúraim per capall, comhroinnte",
        },
        {
          before: "Coinne ó bhéal leis an ngabha crú",
          after: "Pleanáil gabha crú le deimhnithe",
        },
      ],
    },
    helper: {
      title: "Cé na bogearraí boghdáin a oireann duitse?",
      lead: "5 cheist chun féachaint an bhfuil EquiSight ar an ardán ceart do do bhoghdán nó do stábla pinsean.",
      questions: [
        {
          id: "size",
          q: "Cé mhéad capall atá i do ghnó?",
          options: [
            {
              label: "Níos lú ná 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Níos mó ná 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Cad é do phríomhghníomhaíocht?",
          options: [
            {
              label: "Ceachtanna a thabhairt den chuid is mó",
              score: 1,
            },
            {
              label: "Stábla pinsean (capaill i bpinsean)",
              score: 3,
            },
            {
              label: "Meascán de cheachtanna + pinsean",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Cé mhéad múinteoir a oibríonn leat?",
          options: [
            {
              label: "Mé féin amháin",
              score: 1,
            },
            {
              label: "2-3 múinteoir",
              score: 2,
            },
            {
              label: "4 nó níos mó",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Conas a eagraíonn tú do chuid fáltanais anois?",
          options: [
            {
              label: "De láimh (Word/Excel)",
              score: 3,
            },
            {
              label: "Clár cuntasaíochta ar leith",
              score: 2,
            },
            {
              label: "Comhtháite in uirlis ceachtanna",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Conas a dhéanann tú cumarsáid le húinéirí?",
          options: [
            {
              label: "Go pearsanta / WhatsApp",
              score: 3,
            },
            {
              label: "Ríomhphost + WhatsApp",
              score: 2,
            },
            {
              label: "Tairseach úinéara san uirlis",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Is féidir uirlis éadrom nó Excel a úsáid faoi láthair — ach scálálann EquiSight leat.",
          body: "Do ghnó ceachtanna beag le múinteoir amháin agus beagán pinsean, ní gá pacáiste cuimsitheach láithreach bonn. Tosaíonn EquiSight saor agus fásann sé le do bhoghdán — gan pian imirce cúpla bliain ó anois.",
          cta: "Tosaigh saor",
        },
        mid: {
          title: "Is uasghrádú loighciúil é EquiSight do do bhoghdán.",
          body: "Múinteoirí iolracha, meascán de cheachtanna agus pinsean, nó fáltanas atá scartha anois — cuachann EquiSight sin in aon sreabhadh oibre amháin. Go háirithe sábhálann an tairseach úinéara go leor cumarsáide ad-hoc.",
          cta: "Iarr léiriú",
        },
        high: {
          title: "Tógadh EquiSight don scála s'agatsa.",
          body: "Stábla pinsean + ceachtanna + múinteoirí iolracha — sin go díreach an áit ina scarann EquiSight é féin ó uirlisí boghdáin clasaiceacha. Sábhálann an tairseach úinéara agus an comhtháthú cúraim capall uaireanta riaracháin agus cumarsáide gach seachtain.",
          cta: "Pleanáil léiriú do do stábla",
        },
      },
    },
    faqTitle: "Ceisteanna coitianta faoi bhogearraí boghdáin",
    faq: [
      {
        q: "Cad iad na bogearraí boghdáin is fearr?",
        a: "Le haghaidh pleanáil ceachtanna amháin tá roinnt roghanna maithe ann. Chomh luath agus a bhíonn stábla pinsean, múinteoirí iolracha nó rianú cúraim capall ag teastáil uait, éiríonn EquiSight mar an réiteach iomlán — gan jugáil uirlisí, ar fad in aon áit amháin.",
      },
      {
        q: "An féidir liom cliaint agus ceachtanna atá ann cheana a allmhairiú?",
        a: "Is féidir. Is féidir sonraí cliaint agus sceidil ceachtanna a allmhairiú trí CSV. Cuidímid le boghdáin ghníomhacha le himirce uair amháin ionas nach gá duit 200 marcach a iontráil de láimh.",
      },
      {
        q: "An n-oibríonn sé freisin do stábla pinsean gan ceachtanna?",
        a: "Is oibríonn. Casann mód stábla pinsean ceachtanna as agus díríonn sé ar thairseach úinéara, beathú/cúram, pleanáil gabha crú agus costais a chur ar aghaidh per capall.",
      },
      {
        q: "An féidir le marcaigh clárú agus íoc leo féin?",
        a: "Is féidir. Trí chuntas dá gcuid féin is féidir le marcaigh féachaint cé na ceachtanna atá oscailte, clárú, táillí ceachta a íoc le iDEAL agus cártaí ceachta a cheannach.",
      },
      {
        q: "Cad faoi phríobháideachas sonraí capall agus úinéara?",
        a: "Tá ról ag gach duine (úinéir, marcach, múinteoir, fostaí). De réir ról ní fheiceann tú ach an méid a theastaíonn uait. Ní fheiceann úinéirí ach a gcapall féin, ní fheiceann marcaigh ach a gceachtanna féin.",
      },
      {
        q: "An féidir le EquiSight nascadh le mo bhogearraí cuntasaíochta?",
        a: "Is féidir, tá nasc le Exact, Moneybird agus e-Boekhouden ar fáil. Sreabhann sonraisc go huathoibríoch isteach i do chuntasaíocht ansin.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Aip traenála capaill: comparáid & treoir roghnaithe do chóitseálaithe 2026",
      description: "Déan comparáid idir aipeanna traenála do chapall agus marcach: dialann traenála, físeán, spriocanna, anailís prótacail agus bainistíocht cliant. Faigh an uirlis cheart do chóitseálaithe.",
      keywords: [
        "aip traenála capaill",
        "aip teagascóra",
        "aip traenála capaill",
        "aip cóitseála marcaí",
        "dialann traenála capaill",
        "prótacal dressúir a anailísiú",
        "bogearraí traenála capall",
      ],
    },
    hero: {
      eyebrow: "Treoir roghnaithe · bogearraí traenála",
      breadcrumbLabel: "Aip traenála",
      title: "Aip traenála capaill: treoir roghnaithe iomlán do theagascóirí agus cóitseálaithe.",
      intro: "Bíonn traenálaí nó teagascóir ag déileáil le péirí, ceachtanna, físeáin, spriocanna agus comórtais. Déan comparáid idir na haipeanna traenála is fearr do dhaoine a oibríonn le capaill agus roghnaigh an t-ardán a fhásfaidh le do chóitseáil i 2026 freisin.",
      pills: [
        {
          icon: "Target",
          label: "Spriocanna & pleanáil",
        },
        {
          icon: "Video",
          label: "Anailís físeáin",
        },
        {
          icon: "TrendingUp",
          label: "Dul chun cinn",
        },
        {
          icon: "Users",
          label: "Cliaint/péirí",
        },
      ],
      ctas: [
        {
          label: "Tosaigh saor in aisce mar traenálaí",
          href: "#start",
          primary: true,
        },
        {
          label: "Go dtí an tábla comparáide",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Cén fáth a gcuireann cóitseáil WhatsApp bac ar traenálaithe.",
      lead: "Úsáideann formhór na traenálaithe uirlisí scartha: WhatsApp le haghaidh cumarsáide, leabhar nótaí le haghaidh ceachtanna, YouTube nó WeTransfer le haghaidh físeán agus Excel le haghaidh torthaí comórtais. Ag 5 marcach oibríonn sé. Ag 20 marcach cailltear faisnéis, déanann tú dearmad de spriocanna agus cailleann tú greim ar dhul chun cinn aonair.",
      items: [
        "Cá bhfuil sprioc Anouk don séasúr seo?",
        "Cén físeán a sheol mé chuig Bram an mhí seo caite?",
        "An bhfaca Lara anailís prótacail a comórtais dheireanach?",
        "Cé mhéad uair sa tseachtain a thraenálann gach péire?",
        "An léigh úinéir Stardust mo threoracha traenála?",
        "Cathain a thug mé aiseolas ar impuls luaineach an uair dheireanach?",
      ],
    },
    what: {
      title: "Cad é aip traenála do chapall agus marcach?",
      lead: "Comhcheanglaíonn aip traenála CRM cóitseála (péirí, ceachtanna, spriocanna), dialann traenála in aghaidh an chapaill, aiseolas físeáin, pleanáil comórtais agus anailís prótacail. Ní gá WhatsApp/YouTube/Excel scartha a thuilleadh, ach ardán amháin ina n-oibríonn an traenálaí agus an marcach le chéile.",
      targetGroupsTitle: "Cén cineál traenálaí atá sé seo dírithe air?",
      targetGroups: [
        {
          icon: "Target",
          title: "Teagascóir dressúir",
          body: "Prótacal a scanadh, tráchtaireacht giúiré a nascadh le spriocanna traenála, dul chun cinn a fheiceáil.",
        },
        {
          icon: "Activity",
          title: "Traenálaí léimní",
          body: "Pleanáil cúrsa, aiseolas babhta, bainistíocht airde in aghaidh an chapaill.",
        },
        {
          icon: "Award",
          title: "Cóitseálaí imeachtaí",
          body: "Trí dhisciplín, trí phlean — le feiceáil uile taobh le taobh.",
        },
        {
          icon: "TrendingUp",
          title: "Cóitseálaí feidhmíochta (spórt)",
          body: "Rianú EPI, comórtais, spriocanna — do lúthchleasaithe agus a gfoirne.",
        },
        {
          icon: "Users",
          title: "Teagascóir ridíochta",
          body: "Ranganna grúpa + cóitseáil aonair in aon aip amháin.",
        },
        {
          icon: "Heart",
          title: "Cóitseálaí áineasa",
          body: "Teiripe eachaí, tosaitheoirí, úinéirí le capall amháin.",
        },
      ],
    },
    criteria: {
      title: "Cad iad na ceanglais atá ar aip traenála mhaith?",
      lead: "Is obair dhaonna í traenáil, ach déanann an uirlis cheart tú 30-50% níos éifeachtaí agus cabhraíonn sí le marcaigh dul i bhfeabhas idir cheachtanna freisin.",
      items: [
        {
          icon: "Users",
          title: "Bainistíocht péirí",
          body: "Capall + marcach mar aon aonad, le leibhéal, spriocanna, dul chun cinn agus stair.",
        },
        {
          icon: "ClipboardList",
          title: "Nótaí ceachta & spriocanna",
          body: "Nóta le pointí fócais in aghaidh gach ceachta, nasctha le spriocanna fadtéarmacha.",
        },
        {
          icon: "Video",
          title: "Aiseolas físeáin",
          body: "Uaslódáil físeán, clibeáil nóiméid, cuir aiseolas labhartha nó scríofa leis.",
        },
        {
          icon: "Target",
          title: "Anailís comórtais & prótacail",
          body: "Scan prótacail (KNHS/FEI), féach scóir in aghaidh gach rannáin, tráchtaireacht giúiré agus treochtaí.",
        },
        {
          icon: "Calendar",
          title: "Pleanáil & cártaí ceachta",
          body: "Clár ama, íocaíochtaí, síntiúis agus meabhrúcháin uathoibríocha.",
        },
        {
          icon: "Share2",
          title: "Cumarsáid chuig an marcach",
          body: "Feiceann an marcach a leathanach féin le ceachtanna, físeáin, spriocanna agus aiseolas.",
        },
      ],
    },
    comparison: {
      title: "EquiSight i gcomparáid le haipeanna traenála eile.",
      lead: "Díríonn roinnt uirlisí traenála ar ionadaíocht WhatsApp, díríonn cinn eile ar anailís prótacail. Comhcheanglaíonn EquiSight an dá rud le comhad fíor capaill — ionas go mbíonn an marcach ag dul i bhfeabhas idir cheachtanna freisin.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Tosaigh saor in aisce",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Bainistíocht péirí",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nótaí ceachta & aiseolas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Spriocanna fadtéarmacha",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Uaslódáil físeáin + aiseolas",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Scanadh prótacail KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Innéacs Feidhmíochta)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Féilire comórtais",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Tairseach marcaí",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Cárta ceachta / síntiús",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Íocaíochtaí ar líne",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Comhad capaill comhtháite",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Gabha / tréidlia le feiceáil",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Don teagascóir AGUS don marcach",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Il-chapall in aghaidh marcaí",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparáid bunaithe ar ghnéithe atá ar fáil go poiblí i mí Eanáir 2026. Tá EquiSight uathúil maidir le hanailís prótacail + EPI agus comhcheanglaíonn sé seo le bainistíocht ghinearálta capall.",
    },
    why: {
      title: "Cén fáth a dtairgeann EquiSight taithí traenála difriúil.",
      lead: "Críochnaíonn formhór na n-uirlisí traenála nuair a chríochnaíonn an ceacht. Leanann EquiSight ar aghaidh — i gcomhad an chapaill, san anailís comórtais, sa chomhoibriú leis an tréidlia agus an t-úinéir.",
      points: [
        {
          icon: "TrendingUp",
          title: "Scanadh prótacail → sprioc traenála",
          body: "Scan prótacal KNHS agus feic láithreach cé na rannáin a dteastaíonn aird uathu. Tagann spriocanna chun cinn go huathoibríoch.",
        },
        {
          icon: "Sparkles",
          title: "Neartaíonn EquiCoach do shúil",
          body: "Léiríonn sonraí ó cheachtanna, comórtais agus prótacail iolracha patrúin nach gcoinnítear i do cheann.",
        },
        {
          icon: "Share2",
          title: "Comhtháite leis an gcapall",
          body: "Feiceann an traenálaí stair vacsaínithe, gabha agus gortuithe an chapaill — ná pleanáil traenáil le linn téarnaimh.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Do dhressúr agus léimneach",
      title: "Cad a bhíonn i gcomhad cóitseála in EquiSight.",
      lead: "In aghaidh gach péire gheobhaidh tú sruth cóitseála a choinníonn gach rud le chéile — ná caill rudaí i WhatsApp a thuilleadh.",
      items: [
        "Nótaí ceachta le pointí fócais in aghaidh gach seisiúin",
        "Spriocanna fadtéarmacha + garspriocanna",
        "Uaslódáil físeáin le tráchtanna cód ama",
        "Scanadh prótacail KNHS/FEI le scóir",
        "Tráchtaireacht giúiré nasctha le traenáil",
        "Torthaí comórtais agus treochtaí EPI",
        "Teagmháil cliant agus stair ceachtanna",
        "Cárta ceachta / síntiús / sonraisc",
        "Graf dul chun cinn in aghaidh gach disciplíne",
        "Rochtain roinnte le húinéir an chapaill",
      ],
      ctaLabel: "Féach an mhodúl traenálaí",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Ó WhatsApp + YouTube go EquiSight Traenálaí.",
      lead: "Go praiticiúil: seo mar a athraíonn d'obair chun cinn cóitseála.",
      rows: [
        {
          before: "WhatsApp le naisc físeáin scartha",
          after: "Físeán le haiseolas cód ama i gcomhad",
        },
        {
          before: "Leabhar nótaí in aghaidh gach marcaí",
          after: "Dialann cóitseála le spriocanna + stair",
        },
        {
          before: "Excel le scóir comórtais",
          after: "Graf EPI + anailís prótacail",
        },
        {
          before: "Spriocanna béil",
          after: "Garspriocanna le táscaire dul chun cinn",
        },
        {
          before: "Uirlis faturaithe ar leith",
          after: "Ceachtanna + iDEAL + síntiús san aip",
        },
        {
          before: "Ríomhphost chuig úinéir faoi dhul chun cinn",
          after: "Leanann úinéir ina amharc féin",
        },
      ],
    },
    helper: {
      title: "Cén aip traenála a oireann duitse?",
      lead: "5 cheist chun féachaint an bhfuil luach breise ag uirlis chóitseála speisialaithe do do chleachtas.",
      questions: [
        {
          id: "clients",
          q: "Cé mhéad péire gníomhach atá á gcóitseáil agat?",
          options: [
            {
              label: "Níos lú ná 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Níos mó ná 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Cad í do phríomhdisciplín?",
          options: [
            {
              label: "Dressúr",
              score: 3,
            },
            {
              label: "Léimneach",
              score: 2,
            },
            {
              label: "Áineas / ilchineálach",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "An n-úsáideann tú físeán sa chóitseáil?",
          options: [
            {
              label: "Go hannamh",
              score: 0,
            },
            {
              label: "Uaireanta (de láimh)",
              score: 2,
            },
            {
              label: "Go minic — go córasach",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "An gcóitseálann tú marcaigh comórtais?",
          options: [
            {
              label: "Ní dhéanaim, áineas",
              score: 0,
            },
            {
              label: "Comórtais ó am go chéile",
              score: 2,
            },
            {
              label: "Go minic — cártaí tosaithe lárnach",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Ar mhaith leat do chóitseáil a thomhas?",
          options: [
            {
              label: "Ní maith, is leor intuition",
              score: 0,
            },
            {
              label: "Ba mhaith, ach níl am agam",
              score: 2,
            },
            {
              label: "Is maith — cóitseáil bunaithe ar shonraí",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Is leor uirlis shimplí nó fiú WhatsApp — don am seo.",
          body: "Do níos lú ná 5 marcach gan mórán físeáin nó comórtais tá aip cóitseála iomarcach. Tosaíonn EquiSight saor in aisce, mar sin is féidir leat é a thriail nuair a fhásann do chleachtas.",
          cta: "Tosaigh saor in aisce",
        },
        mid: {
          title: "Déanann EquiSight Traenálaí níos éifeachtaí go córasach thú.",
          body: "Le 5-15 péire cailleann tú uaireanta in aghaidh na míosa ar WhatsApp agus físeáin scartha. Bailíonn EquiSight gach rud le chéile, scanann prótacail go huathoibríoch agus cinnteoidh sé gur féidir le marcaigh a n-aiseolas a fheiceáil i gcónaí.",
          cta: "Bain triail as modúl Traenálaí",
        },
        high: {
          title: "Tógadh EquiSight do scála do chóitseála.",
          body: "Marcaigh iolracha, físeán, comórtais agus cóitseáil bunaithe ar shonraí: seo go díreach cá ndéanann EquiSight idirdhealú. Tugann EPI + scanadh prótacail + comhad capaill buntáiste duit nach bhfuil ag iomaitheoirí.",
          cta: "Pleanáil léiriú do do chleachtas cóitseála",
        },
      },
    },
    faqTitle: "Ceisteanna coitianta faoi aipeanna traenála",
    faq: [
      {
        q: "Cad í an aip traenála is fearr do chapall agus marcach?",
        a: "Do chumarsáid amháin is leor go leor uirlisí (fiú WhatsApp). Do spriocanna, anailís físeáin, scanadh prótacail, rianú comórtais agus bainistíocht cliant in aon uirlis amháin is é EquiSight an réiteach is iomláine — go háirithe toisc go gcoinnítear súil ar an gcapall féin freisin, ní ar an bpéire amháin.",
      },
      {
        q: "An féidir le EquiSight prótacail comórtais a léamh go huathoibríoch?",
        a: "Is féidir. Uaslódáil prótacal KNHS nó FEI agus baineann EquiSight na scóir in aghaidh gach rannáin, tráchtaireachtaí giúiré agus nascann sé seo leis an bpéire. Feiceann tú treochtaí thar chomórtais iolracha.",
      },
      {
        q: "Cad é an EPI (Equestrian Performance Index)?",
        a: "Is scór EquiSight é EPI a thiontaíonn torthaí comórtais iolracha ina innéacs feidhmíochta inchomparáide. Leis sin feiceann tú fíordhul chun cinn tríd ranganna agus giúiréanna éagsúla.",
      },
      {
        q: "An féidir le marcaigh mo cheachtanna a chur in áirithe agus íoc astu féin?",
        a: "Is féidir. Logálann marcaigh isteach, feiceann siad amanna ceachta atá ar fáil, ceannaíonn siad cártaí ceachta agus íocann siad trí iDEAL. Is tusa a chinneann cad is mian leat a thairiscint.",
      },
      {
        q: "An n-oibríonn sé freisin do theagascóir a oibríonn timpeall scoile marcaíochta?",
        a: "Oibríonn. Is féidir leat oibriú mar traenálaí féinfhostaithe le do chuid cliant féin gan cuntas scoile marcaíochta a nascadh. Íocann cliaint go díreach thú.",
      },
      {
        q: "An féidir liom físeáin agus nótaí atá agam cheana féin a aistriú?",
        a: "Is féidir físeáin a uaslódáil in aghaidh gach péire nó trí uirlis uaslódála baisce. Iompórtáil nótaí trí CSV. Cabhraímid le traenálaithe gníomhacha le himirce aonuaire.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Treoir & cabhair roghnúcháin do bhogearraí bainistíochta capall | EquiSight",
      description: "Gach treoir EquiSight in aon áit amháin: comparáidí bogearraí bainistíochta capall, pórúcháin, mánaistir agus traenála, móide cabhair roghnúcháin do 2026.",
      keywords: [
        "treoracha bogearraí capall",
        "cabhair roghnúcháin bainistíochta capall",
        "comparáid bogearraí pórúcháin",
        "treoir bogearraí mánaistir",
        "comparáid aip traenála",
      ],
    },
    hub: {
      eyebrow: "Mol · treoracha",
      breadcrumbLabel: "Treoracha",
      title: "Ceithre threoir chuimsitheacha chun na bogearraí capaill cearta a roghnú.",
      intro: "Cabhair roghnúcháin dhomhain do gach spriocghrúpa: táblaí comparáide, critéir, samplaí agus tráth na gceist idirghníomhach. Cliceáil isteach sa treoir a oireann do do chás féin, nó déan iniúchadh ar na hailt dhomhne faoi gach cnuasach ar dtús.",
      stats: {
        guides: "4 cabhair roghnúcháin",
        articles: "15 alt domhain",
        fair: "Comparáid chóir",
      },
      readMoreCta: "Léigh an treoir iomlán",
      relatedHeading: "Ailt dhomhna",
      articlesCountSingular: "{{count}} alt domhain",
      articlesCountPlural: "{{count}} alt domhain",
      articlesCountAria: "Líon altanna an chnuasaigh",
      lastUpdatedPrefix: "Nuashonraithe",
      lastUpdatedAria: "Dáta an nuashonraithe dheireanaigh ar an gcnuasach seo",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Cabhair roghnúcháin aip bainistíochta capall",
        blurb: "Déan comparáid idir na haipeanna bainistíochta capall is cáiliúla agus faigh amach cé acu a oireann d'úinéir, do stábla nó do ghnó pórúcháin. Tábla comparáide cóir san áireamh agus cabhair roghnúcháin 5 cheist.",
        audience: "D'úinéirí, do mháistrí stábla agus do gach duine a bhíonn ag plé le capaill agus atá ag lorg léargas.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Comparáid bogearraí pórúcháin",
        blurb: "Ó thimthriall na láir go dtí forbairt searraigh: féach cé na bogearraí pórúcháin a oibríonn i ndáiríre do do líon láracha, do mhodh pórúcháin agus do cheanglais chlárúcháin.",
        audience: "Do phóreoirí (caitheamh aimsire san áireamh), do ghnónna pórúcháin agus d'úinéirí stailín.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Cabhair roghnúcháin bogearraí mánaistir",
        blurb: "Pleanáil rang, riarachán marcach, tairseach úinéara agus sonrascaíocht — in aon uirlis amháin. Déan comparáid idir na roghanna do mhánaistirí agus stáblaí pinsean in 2026.",
        audience: "Do mhánaistirí, stáblaí pinsean agus gnónna marcaíochta.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Cabhair roghnúcháin aip traenála",
        blurb: "CRM cóitseála, aiseolas físeáin, scanadh prótacail KNHS agus spriocanna do gach comhcheangal. Cé acu aip traenála a oireann do do chleachtas cóitseála?",
        audience: "D'oidí, do thraenálaithe agus do chóitseálaithe.",
      },
    ],
    closing: {
      eyebrow: "Cén fáth na treoracha seo",
      title: "Comparáid chóir, ní praghsanna amháin.",
      body1: "Is fógraí i gclóca eile a bhíonn i go leor 'leathanach comparáide'. Cuireann ár dtreoracha gnéithe, spriocghrúpaí agus iomaitheoirí taobh le taobh ar an gcaoi a dhéanfadh foinse neamhspleách eolais é. Tagann EquiSight chun cinn go nádúrtha mar réiteach cuimsitheach, ach léifidh tú go hionraic freisin cá bhfuil aipeanna eile níos láidre.",
      body2: "Freagraíonn na hailt dhomhna faoi gach treoir na ceisteanna praiticiúla a thagann as an gcinneadh: \"Cathain a dhéantar an chéad ультрафhuaim tar éis insimnithe\", \"Conas a uathoibrím sonrascaíocht mánaistir\", \"Conas a dhéanaim anailís ar phrótacal iomaíochta\". Gan bolgam margaíochta — cúrsaí praiticiúla amháin.",
    },
    hubName: "Treoracha EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Cén fáth a bhfuil sé seo pianmhar",
      basics: "Bunrudaí",
      criteria: "Cad a dhéanann é maith?",
      comparison: "Comparáid chothrom",
      why: "An difríocht",
      beforeAfter: "Ó scaipeadh go soiléireacht",
      helper: "5 cheist",
    },
    table: {
      feature: "Gné",
      today: "Inniu",
      withEquisight: "Le EquiSight",
    },
    helper: {
      questionLabel: "Ceist {{current}} as {{total}}",
      answerPrompt: "Freagair an {{count}} cheist atá fágtha chun moladh a fheiceáil.",
      answerPromptPlural: "Freagair na {{count}} ceisteanna atá fágtha chun moladh a fheiceáil.",
      resultEyebrow: "Do thoradh",
    },
    targetGroupsFallback: "Cé dó a bhfuil sé seo dírithe?",
    faqTitleFallback: "Ceisteanna coitianta",
  },
};

export default CORNERSTONES;
